import React, { useState, useEffect } from "react";
import "./Storage.css";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import SideGallery from "../repeats/sideGallery/SideGallery";
import PersonalDetails from "../repeats/personalDetails/PersonalDetails";
import PaymentSuccess from "../repeats/paymentSuccess/PaymentSuccess";
import Post from "../blog/Post";
import { addLead, resetLead } from "../../redux/actions-exporter";

// import storing from "../../assets/images/storing.jpg";
// import privateStorage from "../../assets/images/PS/privateStorage.jpg";
import businessStorage from "../../assets/images/PS/businessStorage.jpg";
import galleryImg1 from "../../assets/images/BS/50_off_banner_2-bg.jpeg";
import galleryImg2 from "../../assets/images/BS/BUSINESS PARK-1.jpg";
import galleryImg3 from "../../assets/images/BS/Chapman_Final-17-of-75.jpeg";
import galleryImg4 from "../../assets/images/BS/stockage24-box-louer-box-location-depot-louer-garage-location-Stockage_1.png";
import galleryImg5 from "../../assets/images/BS/small1.jpg";
import galleryImg6 from "../../assets/images/BS/Professional-removals-and-storage-services-in-Bozeat-Wollaston-Irchester-Northamptonshire.jpg";
import img1 from "../../assets/images/Blog/1.jpg";

const galleryArr = [
  {
    img: galleryImg1,
  },
  {
    img: galleryImg2,
  },
  {
    img: galleryImg3,
  },
  {
    img: galleryImg4,
  },
  {
    img: galleryImg5,
  },
  {
    img: galleryImg6,
  },
];

const LEAD_SOURCE = "אחסנה עסקית";

const BusinessStorage = ({ mainLogo }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({ source: LEAD_SOURCE });
  const addedLead = useSelector((state) => state.lead.addedLead);
  const [send, setSend] = useState(false);
  const [validated, setValidated] = useState(false);

  const [start, setStart] = useState(true);

  useEffect(() => {
    if (start || send) document.querySelector(".homeTitle").scrollIntoView();
    setStart(false);
  }, [send]);

  useEffect(() => {
    if (addedLead) {
      setSend(true);
      dispatch(resetLead());
      setForm({ source: LEAD_SOURCE });
    }
  }, [addedLead]); // eslint-disable-line

  // const servicesArr = [
  //   {
  //     header: "פרטית",
  //     img: privateStorage,
  //     link: "/privateStorage",
  //   },
  //   {
  //     header: "עסקית",
  //     img: businessStorage,
  //     link: "/businessStorage",
  //   },
  // ];
  const handleSend = (e) => {
    e.preventDefault();
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation();
    } else {
      dispatch(addLead(form, "only_storage"));
    }
    setValidated(true);
  };
  return (
    <>
      <div className="page_banner">
        <img src={businessStorage} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1> אחסנה עסקית</h1>
            <p>אחסנת ציוד מפעלים ומשרדים</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/storage" />
            <MainBtn text="אחסנה פרטית" link="/privatestorage" isLight={true} />
          </div>
        </div>
      </div>

      <Pros />
      <div className="servicesDiv">
        <h1 className="homeTitle">פרטים לחזרה</h1>
        <div className="splitDiv">
          <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
              header="אחסנה עסקית"
              galleryArr={galleryArr}
            />
          </div>

          <div className="formSide">
            {send ? (
              <PaymentSuccess
                text1="תודה שבחרת בנו!"
                text2="נציג יחזור אליך בהקדם"
              />
            ) : (
              <>
                <Form
                  className="formBox"
                  noValidate
                  validated={validated}
                  onSubmit={handleSend}
                >
                  <Row className="mb-3 row">
                    <Form.Group
                      as={Col}
                      className="mb-3"
                      controlId="formBasicName"
                    >
                      <Form.Label className="fw-semibold mb-2">
                        אזור אחסנה
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="area"
                        onChange={(e) =>
                          setForm({
                            ...form,
                            extraFields: {
                              ...form.extraFields,
                              [e.target.name]: e.target.value,
                            },
                          })
                        }
                      >
                        <option value="בחר אזור">בחר אזור</option>
                        <option value="center">מרכז</option>
                        <option value="sharon">שרון</option>
                        <option value="north sharon">צפון השרון</option>
                        <option value="north">צפון</option>
                        <option value="shfela">שפלה</option>
                        <option value="south">דרום</option>
                        <option value="jerusalem">ירושלים והסביבה</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        נא לבחור אזור
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <PersonalDetails
                    onChange={(newValue) => setForm({ ...form, ...newValue })}
                  />
                  <Button
                    style={{
                      background: "var(--primary)",
                      border: "none",
                      width: "100%",
                    }}
                    text="שליחה"
                    type="submit"
                    className="filter-btn"
                  >
                    שליחה
                  </Button>
                  {/* <div className="contact-btnDiv send">
                    <MainBtn
                      text="שליחה"
                      handleSend={() =>
                        dispatch(addLead(form))
                      }
                    />
                  </div> */}
                </Form>
              </>
            )}
          </div>
        </div>
      </div>

      <Reviews />

      <div className="articlesDiv">
        <Post
          title="טיפים לאריזה"
          img={img1}
          text="  לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח. עמחליף נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן צש בליא, מנסוטו צמלח לביקו ננבי, צמוקו בלוקריה שיצמה ברורק. קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם. וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק. קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.        נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף.אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף לפרומי בלוף קינץ תתיח לרעח.לת צשחמי מוסן מנת.להאמית קרהשק סכעיט דז מא, מנכם למטכין נשואי מנורך.קונסקטורר אדיפיסינג אלית.סת אלמנקום ניסי נון ניבאה.דס איאקוליס וולופטה דיאם.וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק.קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.         קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח.עמחליף נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף.אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף ליבם סולגק.בראיט ולחת צורק מונחף, בגורמי מגמש.תרבנך וסתעד לכנו סתשם השמה - לתכי מורגם בורק ? לתיג ישבעס.        קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.        לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית.סת אלמנקום ניסי נון ניבאה.דס איאקוליס וולופטה דיאם.וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק.הועניב היושבב שערש שמחויט - שלושע ותלברו חשלו שעותלשך וחאית נובש ערששף.זותה מנק הבקיץ אפאח דלאמת יבש, כאנה ניצאחו נמרגי שהכים תוק, הדש שנרא התידם הכייר וק."
        />
      </div>

      <Footer isContact={false} />
    </>
  );
};

export default BusinessStorage;
